import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    listLoading: false,
    exportLoading: false,
    actionsLoading: false,
    totalCount: 0,
    entities: [],
    newContestType: {}
}

export const callTypes = {
    list: "list",
    action: "action"
};

export const AddContestTypeSlice = createSlice({
    name: "addContestsType",
    initialState: initialState,
    reducers: {
        catchError: (state, action) => {
            state.error = `${action.type}: ${action.payload.error}`;
            if (action.payload.callType === callTypes.list) {
                state.listLoading = false;
            } else {
                state.actionsLoading = false;
            }
        },
        startCall: (state, action) => {
            state.error = null;
            if (action.payload.callType === callTypes.list) {
                state.listLoading = true;
            } else {
                state.actionsLoading = true;
            }
        },
        endCall: (state, action) => {
            state.error = null;
            if (action.payload.callType === callTypes.list) {
                state.listLoading = false;
            } else {
                state.actionsLoading = false;
            }
        },
        emptyList: (state, action) => {
            state.error = null;
            state.entities = [];
            // state.totalCount = 0;
            state.exportData = [];
        },
        createContestType: (state, action) => {
            const { newContestType } = action.payload;
            state.error = null;
            console.log("newContestType",newContestType);
            state.newContestType = newContestType;
          },
    }
})